interface countMatchingCollectionsTypes {
  title?: string;
}

async function countMatchingCollections(params: countMatchingCollectionsTypes) {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const baseUrl = new URL(`${serverURL}/api/collections/count`);

  const searchParams = new URLSearchParams({});

  if (params.title) searchParams.set("title", params.title);

  baseUrl.search = searchParams.toString();

  try {
    const res = await fetch(baseUrl.toString(), {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await res.json();
    return result.count;
  } catch (error) {
    return null;
  }
}

export default countMatchingCollections;
